/** What staff type for a person (#731), and the checks made before asking the server: shared by Add person and the edit on their sheet. */
import type { PersonField, PersonInput } from "../../../api/people";

export type Draft = PersonInput;
export type FieldErrors = Partial<Record<PersonField, string>>;

export const EMPTY: Draft = { first_name: "", last_name: "", email: "", phone: "" };

/** An address by its shape, as the server's own check reads it: something, one @, a domain with a dot. */
const EMAIL_SHAPE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/** What the server would refuse anyway, said before asking it. */
export function checkDraft(draft: Draft): FieldErrors {
  const errors: FieldErrors = {};
  if (!draft.first_name.trim()) errors.first_name = "Enter a first name.";
  if (!draft.last_name.trim()) errors.last_name = "Enter a last name.";
  if (!draft.email.trim()) errors.email = "Enter an email.";
  else if (!EMAIL_SHAPE.test(draft.email.trim())) errors.email = "Enter an email like name@example.com.";
  return errors;
}

/** The draft as it is sent: every value trimmed. */
export const trimmed = (draft: Draft): Draft => ({ first_name: draft.first_name.trim(), last_name: draft.last_name.trim(), email: draft.email.trim(), phone: draft.phone.trim() });
